import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Question } from 'bookraw/shared/models/question.model';

@Injectable()
export class QuestionsService extends ListService<Question> {

  url: string = '/api/admin/questions';

}
